import React, { FC, useState, useMemo, useEffect } from 'react'
import { observer } from 'mobx-react'
import DecorationMobx from '@mobx/app/decoration.mobx'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { GetCardItem, MyCardDetail, MyCardItem, CardLevelModal } from '@cps'
import HeaderModule from '../HeaderModule'
import { IonSlides, IonSlide, useIonViewWillEnter } from '@ionic/react'
import { useHistoryNew, modalLayer } from '@utils'
import CardInfoModule from '../CardInfoModule'
import { find, findIndex } from '@dt/fe-utils/dist/lodash'
import './index.scss'

interface IProps {
  cardId?: string;
}

const SecondTempModule: FC<IProps> = (props: IProps) => {
  const { cardId } = props
  const history = useHistoryNew()
  const { mktDecorates } = DecorationMobx
  const { cardList, cardListForMy } = memberMobx
  const { bestDiscountCard } = memberCardMobx
  const [cardShow, setCardShow] = useState<number>(0)
  const [coverCardInfo, setCoverCardInfo] = useState<any>({})
  const [currCardList, setCurrCardList] = useState<IMemberCardInfo[]>([])
  const cardDropDown = () => {
    if (cardListForMy.length > 0) setCardShow(cardShow < 2 ? 2 : 1)
  }
  const openCardDetail = (e: any, type?: number) => {
    e.stopPropagation()
    modalLayer(MyCardDetail, { cardInfo: { detailType: type || null, ...coverCardInfo } }, 'CardDetail').then((url: any) => {
      history.push(url)
    }, () => { })
  }
  const pageCards = useMemo(() => {
    if (currCardList.length > 0 && cardListForMy.length > 0) {
      return currCardList.map((item: any) => {
        return memberMobx.cardListMap[item.cardId] || item
      })
    } else {
      return memberMobx.cardListForMy
    }
  }, [currCardList, memberMobx.cardListForMy])
  const initOpts = {
    initialSlide: findIndex(pageCards, (item) => `${item.cardId}` === cardId) || 0,
    autoplay: false,
    loop: false,
    on: {
      beforeInit () {
        setCoverCardInfo(cardListForMy[0] || {})
      },
      slideChange () {
        const swiper = this as any
        if (cardListForMy && cardListForMy.length) {
          setCoverCardInfo(cardListForMy[swiper.activeIndex])
        }
      }
    }
  }
  useIonViewWillEnter(() => {
    setCurrCardList(cardListForMy)
    setCardShow(0)
  })
  useEffect(() => {
    if (!currCardList.length) {
      setCurrCardList(memberMobx.cardListForMy)
    }
  }, [currCardList, memberMobx.cardListForMy])
  useEffect(() => {
    if (cardId && cardListForMy.length && !memberMobx.hasShowLvInfo) {
      memberMobx.updateHasShowLvInfo(true)
      modalLayer(CardLevelModal, { cardInfo: find(cardListForMy, (item) => `${item.cardId}` === cardId) }).then(() => { }, () => { })
    }
  })
  return (
    <>
      <div
        className={`second-temp-module ${cardShow === 2 && 'temp-area-show'}`}
        style={mktDecorates.member.bgType === 'color' ? {
          backgroundColor: mktDecorates.member.bgValue
        } : {
          backgroundImage: `Url(${mktDecorates.member.bgValue})`
        }}
      >
        <div className='temp-area'>
          {
            memberMobx.isLogin && memberCardMobx.allCardList.length > 0 &&
              <div className='card-panel'>
                {
                  cardList.length === 0 && memberCardMobx.cardList.length > 0 &&
                    <div className='guide-area'>
                      {
                        bestDiscountCard && <GetCardItem cardInfo={bestDiscountCard} hasDetail={false}></GetCardItem>
                      }
                    </div>
                }
                {
                  pageCards.length > 0 &&
                    <IonSlides className='card-slides' options={initOpts} key={pageCards.map((item: any) => item.addTime).join('_') + cardId}>
                      {
                        pageCards.map((item: any, index: number) => {
                          return (
                            <IonSlide key={index} data-cypid='mmgMCardItem' onClick={cardDropDown}>
                              <div className='card-area'>
                                <MyCardItem source='my' detailType={cardShow === 2 ? 'open' : 'hide'} cardInfo={item}></MyCardItem>
                              </div>
                            </IonSlide>)
                        })
                      }
                    </IonSlides>
                }
              </div>
          }
        </div>
      </div>
      <div className='new-member-info' style={{ color: mktDecorates.member.fontColor }}>
        <HeaderModule></HeaderModule>
        <CardInfoModule coverCardInfo={memberMobx.isLogin ? coverCardInfo : {}} onChange={(e: any) => { openCardDetail(e, 2) }}></CardInfoModule>
      </div>
    </>
  )
}

export default observer(SecondTempModule)
